"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valvasone-arzene": {
    "3e794d30": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "skipSearch": false
    }],
    "casamatta": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94c8df8d": [{
      "hkey": "5a4680bb",
      "slug": "maiaroff",
      "name": "Maiaroff",
      "primary": true,
      "skipSearch": false
    }],
    "majaroff": [{
      "hkey": "5a4680bb",
      "slug": "maiaroff",
      "name": "Maiaroff",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "692036b6": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "skipSearch": false
    }],
    "pozzodipinto": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90cb3ae1": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "skipSearch": false
    }],
    "tabina": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0e99ef9c": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "skipSearch": false
    }],
    "torricella": [{
      "hkey": "56f5da0f",
      "slug": "valvasone-arzene",
      "name": "Valvasone Arzene",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;